module.exports = __webpack_public_path__ + "img/5.6871cca7.jpg";